import { RestRepository } from "../base/RestRepository";
import config from "../config";

export const CollectionsRepository = new RestRepository({
  baseURL: config.api.url,
  path: "collections",
  isPublic: false,
  version: "v1",
});
